import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useRelevancyFeed } from '../model';
import { useRelevancyOptions } from '../store';

import type { EditorialContent } from '@cobalt/utilities';
import { getTeamCompetitionsQuery } from '@queries/competition';
import { useTranslateFn } from '@shared/Translate';

export const useRoofline = (teaser: EditorialContent) => {
  const { feed } = useRelevancyFeed();
  const { options } = useRelevancyOptions();
  const t = useTranslateFn();

  const allCompetitions = useMemo(
    () => feed?.map((item) => item?.teaser?.classification?.competition).filter(Boolean),
    [feed],
  );

  const defaultRoofline = t('roofline-news');

  const type = options.rooflineType;
  const rooflineKey = teaser?.classification?.[type];

  const { data: competition } = useQuery({
    ...getTeamCompetitionsQuery({ competitionIds: allCompetitions }),
    enabled: !!allCompetitions?.length && !!options.showRoofline && type === 'competition',
    select: (res) => res.find((comp) => comp.id === rooflineKey),
  });

  return useMemo(() => {
    if (!rooflineKey || !options.showRoofline || !type) return '';

    if (type === 'competition') {
      if (!competition) return null;
      return { ...competition, phase: teaser?.classification?.phase };
    }

    const tag = `roofline-${rooflineKey.toLowerCase().replaceAll(' ', '-').replaceAll('/', '-')}`;

    return t(tag, { fallback: defaultRoofline });
  }, [competition, defaultRoofline, options.showRoofline, rooflineKey, t, teaser?.classification?.phase, type]);
};
